// action types
// const SHOW_SUCCESS_MODAL = 'rp/toggleSuccessModal/SHOW_SUCCESS_MODAL'
const SHOW_LOADER = 'rp/toggleSuccessModal/SHOW_LOADER'
const HIDE_LOADER = 'rp/toggleSuccessModal/HIDE_LOADER'
const SHOW_INVITE_SUCCESS = 'rp/toggleSuccessModal/SHOW_INVITE_SUCCESS'
const HIDE_INVITE_SUCCESS = 'rp/toggleSuccessModal/HIDE_INVITE_SUCCESS'
const SHOW_CONFIRM_DELETE_MODAL =
  'rp/toggleSuccessModal/SHOW_CONFIRM_DELETE_MODAL'
const HIDE_CONFIRM_DELETE_MODAL =
  'rp/toggleSuccessModal/HIDE_CONFIRM_DELETE_MODAL'
const SHOW_DELETE_SUCCESS_MODAL =
  'rp/toggleSuccessModal/SHOW_DELETE_SUCCESS_MODAL'
const SHOW_CANCEL_PAYMENT_SUCCESS_MODAL =
  'rp/toggleSuccessModal/SHOW_CANCEL_PAYMENT_SUCCESS_MODAL'
const HIDE_DELETE_SUCCESS_MODAL =
  'rp/toggleSuccessModal/HIDE_DELETE_SUCCESS_MODAL'
const HIDE_CANCEL_PAYMENT_SUCCESS_MODAL =
  'rp/toggleSuccessModal/HIDE_CANCEL_PAYMENT_SUCCESS_MODAL'

const initialModalState = {
  showLoader: false,
  showInviteSuccessModal: {
    show: false,
    fromProfile: false,
    fromResetPassword: false,
  },
  showConfirmDeleteModal: false,
  showDeleteSuccess: {
    show: false,
    deletedUserInfo: null,
  },
  showCancelPaymentModal: false,
}
// reducer
export default function userModuleModals(
  state = initialModalState,
  { payload, type },
) {
  switch (type) {
    case SHOW_LOADER:
      return {
        ...state,
        showLoader: payload,
      }
    case HIDE_LOADER:
      return {
        ...state,
        showLoader: '',
      }
    case SHOW_INVITE_SUCCESS:
      return {
        ...state,
        showInviteSuccessModal: {
          ...state.showInviteSuccessModal,
          show: true,
          fromProfile: payload.fromProfile,
          fromResetPassword: payload.fromResetPassword,
        },
      }
    case HIDE_INVITE_SUCCESS:
      return {
        ...state,
        showInviteSuccessModal: {
          ...state.showInviteSuccessModal,
          show: false,
          fromProfile: false,
          fromResetPassword: false,
        },
      }
    case SHOW_CONFIRM_DELETE_MODAL:
      return {
        ...state,
        showConfirmDeleteModal: true,
      }
    case HIDE_CONFIRM_DELETE_MODAL:
      return {
        ...state,
        showConfirmDeleteModal: false,
      }
    case SHOW_DELETE_SUCCESS_MODAL:
      return {
        ...state,
        showDeleteSuccess: {
          show: true,
          deletedUserInfo: payload,
        },
      }
    case HIDE_DELETE_SUCCESS_MODAL:
      return {
        ...state,
        showDeleteSuccess: {
          show: false,
          deletedUserInfo: null,
        },
      }
    case SHOW_CANCEL_PAYMENT_SUCCESS_MODAL:
      return {
        ...state,
        showCancelPaymentModal: payload,
      }
    case HIDE_CANCEL_PAYMENT_SUCCESS_MODAL:
      return {
        ...state,
        showCancelPaymentModal: false,
      }
    default:
      return state
  }
}

// action creators
// payload = boolean
export const showLoader = payload => ({
  type: SHOW_LOADER,
  payload,
})

export const hideLoader = payload => ({
  type: HIDE_LOADER,
  payload,
})

export const showInviteSuccessModal = payload => ({
  type: SHOW_INVITE_SUCCESS,
  payload,
})

export const hideInviteSuccess = payload => ({
  type: HIDE_INVITE_SUCCESS,
  payload,
})

export const showConfirmDelete = payload => ({
  type: SHOW_CONFIRM_DELETE_MODAL,
  payload,
})

export const hideConfirmDelete = payload => ({
  type: HIDE_CONFIRM_DELETE_MODAL,
  payload,
})

export const showDeleteSuccess = payload => ({
  type: SHOW_DELETE_SUCCESS_MODAL,
  payload,
})

export const hideDeleteSuccess = payload => ({
  type: HIDE_DELETE_SUCCESS_MODAL,
  payload,
})

export const showCancelPaymentSuccess = payload => ({
  type: SHOW_CANCEL_PAYMENT_SUCCESS_MODAL,
  payload,
})

export const hideCancelPaymentSuccess = payload => ({
  type: HIDE_CANCEL_PAYMENT_SUCCESS_MODAL,
  payload,
})
